import { TraceHistory } from 'types';

import { checkForAnyAlarm } from 'features/alarms/utils';
import { SliderMark } from '../types';

import { useSnapshot } from 'features/snapshots/api/getSnapshot';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';

const useHighlightSliderAlarms = (
  snapshotId: number,
  traceHistory: TraceHistory[]
) => {
  const { data: modules } = useSystemModules({});
  let sliderMarks: SliderMark[] = [];
  const { data: snapshot } = useSnapshot({ snapshotId });
  const { monitors, markers, masks, thresholds } = snapshot || {};

  const markerDeltas = snapshot?.snapshot_marker_delta;

  if (!modules?.ADVANCED_HISTORY) return [];

  for (let i = 0; i < traceHistory.length; i++) {
    const alarming = checkForAnyAlarm(
      traceHistory[i].trace,
      snapshot?.baseline_trace,
      monitors,
      markers,
      markerDeltas,
      masks,
      thresholds
    );

    if (alarming) {
      sliderMarks.push({
        value: i,
      });
    }
  }

  return sliderMarks;
};

export default useHighlightSliderAlarms;
